import { useEffect, useRef, useState } from "react";
import { FacebookIcon, FacebookShareButton } from "react-share";
import { getReceiptUrls } from "../../../../utils/MenuUtils";
import classes from "./ShareButtons.module.css";

const Facebook = (props) => {
  const [url, setUrl] = useState("none");
  const shareButton = useRef(null);
  const onShareClick = async () => {
    if (url === "none") {
      const selectedInvoiceSummaries = props.getSelectedValues(props.parkingHistoryId);
      let message = await getReceiptUrls(selectedInvoiceSummaries);
      setUrl(message);
    }
  };
  useEffect(() => {
    if (url && url !== "none") {
      shareButton.current?.click();
      setUrl("none");
    }
  }, [url, shareButton]);
  return (
    <FacebookShareButton
      url={url}
      ref={shareButton}
      openShareDialogOnClick={url !== "none"}
      title="FaceBook Share"
      onClick={onShareClick}
    >
      <FacebookIcon size={32} round={true} />
    </FacebookShareButton>
  );
};

export default Facebook;
